










































    import { Vue, Component, Prop } from "../../Infrastructure/CorBase/CoreBase";

	@Component
	export default class BaseTLButton extends Vue {
		@Prop({ type: String, required: false, default: "" }) title?: string;
		@Prop({ type: String, required: false, default: "" }) tooltip?: string;
        @Prop({ type: Boolean, required: false, default: true }) visible?: boolean; // primo na tohle kdyz se odkazeme tam zabranime zobrazeni tooltip vlevoNahore
		@Prop({ type: String, required: false, default: "" }) icon?: string;
		@Prop({ type: Boolean, required: false, default: false }) disabled?: boolean;
		@Prop({ type: Boolean, required: false, default: false }) selected?: boolean;
		@Prop({ type: Number, required: false, default: 0 }) notification?: number;
		@Prop({ type: Boolean, required: false, default: false }) onlyIcon?: boolean;
        @Prop({ type: Boolean, required: false, default: false }) leftIcon?: boolean;
		//puvodni
		@Prop({ type: String, required: false }) to?: string;
		@Prop({ type: String, required: false, default: "" }) iconClass?: string; //odkaz na ikonu buttonIconMedia
		@Prop({ type: String, required: false, default: "main" }) variant?: string;
        @Prop({ type: String, required: false, default: "" }) variantSize?: string; //velikost kdyz neni klasicka tak middle, big
		@Prop({ type: String, required: false, default: "sm" }) size?: string;
		@Prop({ type: Boolean, required: false, default: false }) readonly?: boolean;
		@Prop({ type: Boolean, required: false, default: false }) styleMain?: boolean;
		@Prop({ type: String, required: false, default: "0" }) marginLeft?: string; //odstavení zleva

		//POPIS typy variant
		//normal - normalni tlacitko
		//zpet, odhlaseni
		showPressButton = false;
		mouseDown() {
			this.showPressButton = true;
		}

		showTooltip = false;
        mouseUp() {
            this.showPressButton = false;
		}

		mouseLeave() {
			this.showPressButton = false;
			this.showTooltip = false;
            this.$emit('mouseLeave', true);
		}

		mouseOver() {
			this.showTooltip = true;
            this.$emit('mouseOver', true);
		}

	
		getMainButtonClass() {
			var hoverClass = "hoverButtonMainBase";
            hoverClass += this.variant == "red" ? " hoverButtonMainBaseRed " : "";
			hoverClass += this.variant == "green" ? " hoverButtonMainBaseGreen " : "";		
			return !this.readonly && !this.disabled ? " buttonMainBase " + hoverClass : " buttonMainBase " ;
		}

		getHover() {
            return !this.readonly && !this.disabled ? "cursor: pointer;" : "cursor: default;";
		}

		getOnlyIcon() {
            var result = this.selected == true ? "buttonMainSmallSelected" : "buttonMainSmall";
            result += " " + this.getClassIcon();
			return result;
		}

        getClassMainOnlyIcon() {
            var result = this.variant != "onlyIcon" ? " buttonOnlyIcon " : "buttonOnlyIconNotBorder";
            result = this.variant == "smallRed" ? " buttonOnlyIconRed " : result;
            result = this.variant == "smallBlack" ? " buttonOnlyIcon buttonOnlyIconBlack " : result;
            return result;
        }

		clickButton() {
			if (this.disabled == false && this.readonly == false) {
				this.$emit('clickButton', true);
			}
		}

		showOnlyIcon() {
			return this.onlyIcon == true;
		}

		showNotification() {
			return Number(this.notification) > 0;
		}

		getClassButtonIn() {
			var result = "buttonMainMenuIn ";
			if (this.disabled == true) {
				result += " buttonMainMenuDisable";
			}

			return result;
		}



		getClickClass() {
            var classClick = this.showOnlyIcon() ? " buttonMainOnlyIconClick " : " buttonMainClick ";
            return !this.showPressButton || this.readonly || this.disabled ? "" : classClick;
		}

		showIcon() {
            return this.variant != "small" && this.variant != "normal" && this.variant != "normalBig" && this.variant != "normalGreen" && this.variant != "zrusFiltr" && this.leftIcon == false;
		}

		getToolTip() {
			if ( this.tooltip == '') {
				return this.title;
			}			
			return this.tooltip;
		}

		getTittle() {
			if (this.isIconButton()) {
				return "";
			}
			return this.title;
		}

		getMainText() {
			var result = "buttonMainMenuText " + this.getClickClass();
			switch (this.variant) {
                case "small":
                    result += " buttonMainMenuSmallText";
                    break;
				case "normal":
					result += " buttonMainMenuNormalText";
					break;
                case "normalGreen":
                    result += " buttonMainMenuNormalText";
					break;
                case "normalBig":
                    result += " buttonMainMenuNormalText";
                    break;
				case "zrusFiltr":
					result += " buttonMainMenuZrusFiltrText";
					break;
			}
			return result;
		}

		getMainTypeClass() {
			var result = "buttonMainMenu";
			
			if (this.disabled) {
				result += " buttonMainDisable";
			}
			
			switch (this.variant) {
				case "addTable":
					result = "buttonMainNormalAdd";
					break;
				case "normalBig":
					result = "buttonMainNormalBig";
					break;
				case "small":
					result = "buttonMainSmall";
					break;
				case "normal":
					result = "buttonMainNormal";
					break;
				case "normalGreen":
					result = " buttonMainNormalGreen ";
					break;
				case "red":
					result += " buttonMainBaseRed";
					break;
				case "green":
					result += " buttonMainBaseGreen";
					break;
				case "zrusFiltr":
					result += " buttonMainBaseRemoveFilter";
			}

            switch (this.variantSize) {
                case "middle":
                    result += " buttonMainMiddle ";
                    break;
                case "big":
                    result += "  buttonMainBig ";
                    break;               
			}

			//aby tam byl kurzor i 
			if (this.disabled == false) {
				result += " buttonMainBase ";
			}

            if (this.selected) {
                result += "buttonMainMenuSelected ";
            }

			return result;
		}

		getClassIcon() {
			var result = this.onlyIcon == true ? "" : "buttonMainImgCenter ";
			var icon = this.iconClass;
			switch (this.variant) {
				//case "nova":
				//	icon = "buttonIconSmazat";
				//	break;
			}
            result += icon +  this.getClickClass();
			return result;
		}


		isIconButton() {
			if (this.variant == "buttonIconInfo" ||
				this.variant == "buttonIconEdit" ||
				this.variant == "buttonIconDelete"
			) {
				return true;
			}
			return false;
		}

	}

